// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ci-table-wrapper {
  overflow-x: auto;
  margin-top: 1rem;
  margin-bottom: 1.5rem; /* space below table */
}

.ci-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--hellgruen);
  border-radius: 12px;
  overflow: hidden;
}

.ci-table thead th {
  background-color: var(--dunkelgruen);
  color: var(--blassgruen);
  font-size: calc(1rem + 2px);
}

.ci-table th,
.ci-table td {
  padding: 0.75rem;
  text-align: center;
  border: none;
  font-weight: normal;
  font-family: 'Circular', sans-serif;
}

.ci-table th {
  font-family: 'Staatliches', sans-serif;
}

.ci-table td {
  font-size: calc(1rem - 2px);
  color: var(--dunkelgruen);
}

.ci-table tbody td {
  font-family: 'Circular', sans-serif;
  font-weight: normal;
}

.ci-table th:first-child,
.ci-table td:first-child {
  text-align: left;
}

.ci-table tbody tr:nth-child(even) {
  background-color: var(--blassgruen);
}
`, "",{"version":3,"sources":["webpack://./src/styles/CiTable.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB,EAAE,sBAAsB;AAC/C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".ci-table-wrapper {\n  overflow-x: auto;\n  margin-top: 1rem;\n  margin-bottom: 1.5rem; /* space below table */\n}\n\n.ci-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: var(--hellgruen);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.ci-table thead th {\n  background-color: var(--dunkelgruen);\n  color: var(--blassgruen);\n  font-size: calc(1rem + 2px);\n}\n\n.ci-table th,\n.ci-table td {\n  padding: 0.75rem;\n  text-align: center;\n  border: none;\n  font-weight: normal;\n  font-family: 'Circular', sans-serif;\n}\n\n.ci-table th {\n  font-family: 'Staatliches', sans-serif;\n}\n\n.ci-table td {\n  font-size: calc(1rem - 2px);\n  color: var(--dunkelgruen);\n}\n\n.ci-table tbody td {\n  font-family: 'Circular', sans-serif;\n  font-weight: normal;\n}\n\n.ci-table th:first-child,\n.ci-table td:first-child {\n  text-align: left;\n}\n\n.ci-table tbody tr:nth-child(even) {\n  background-color: var(--blassgruen);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
